'use client';

import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ToastContainer } from 'react-toastify';

import theme from '../theme';
import { BreakpointProvider } from './break-points.provider';

import 'react-toastify/dist/ReactToastify.css';

// ----- Lazy Dialogs -----
const dialogs = [
  dynamic(() => import('./CreatePostDialogs'), { ssr: false }),
  dynamic(() => import('@/components/EmojiPicker/EmojiPicker'), { ssr: false }),
  dynamic(() => import('@/components/Dialogs/ConfirmDialog'), { ssr: false }),
  dynamic(() => import('@components/ShareDialog'), { ssr: false }),
  dynamic(() => import('@components/JoinNonProfit/JoinNonProfitDialog'), { ssr: false }),
  dynamic(() => import('@components/JoinCommunity/JoinCommunityDialog'), { ssr: false }),
  dynamic(() => import('@components/DonateDialog'), { ssr: false }),
  dynamic(() => import('@/components/next-page-components/StripeDonateDialog'), { ssr: false }),
  dynamic(() => import('@/components/next-page-components/ContributionDialog'), { ssr: false }),
  dynamic(() => import('@components/ConnectModal'), { ssr: false }),
  dynamic(() => import('@components/NonProfitOnBoard/NonProfitOnBoardDialog'), { ssr: false }),
  dynamic(() => import('@components/Banner/BannerDialog'), { ssr: false }),
  dynamic(() => import('@components/EditProfile/EditProfileDialog'), { ssr: false }),
  dynamic(() => import('@components/EditAvatarProfile/EditAvatarProfileDialog'), { ssr: false }),
  dynamic(() => import('@components/EditNpoProfile/EditNpoProfileDialog'), { ssr: false }),
  dynamic(() => import('@/components/SocialFeed/postReactionDialog'), { ssr: false }),
  dynamic(() => import('@/components/SocialFeed/PostContributorsDialog'), { ssr: false }),
  dynamic(() => import('@components/NonProfitSignUpPopUp/NonProfitSignUpPopUp'), { ssr: false }),
  dynamic(() => import('@components/CompanyConnectPopUp/CompanyConnectPopUp'), { ssr: false }),
  dynamic(() => import('@components/DonationTrackerPopUp/DonationTrackerPopUp'), { ssr: false }),
  dynamic(() => import('@/components/next-page-components/ContributionTrackerPopUp/ContributionTrackerPopUp'), {
    ssr: false,
  }),
];

export default function Providers({ children }) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <BreakpointProvider>
          <QueryClientProvider client={queryClient}>
            {children}

            {/* Dynamically rendered dialogs */}
            {dialogs.map((DialogComponent, index) => (
              <DialogComponent key={index} />
            ))}

            {process.env.NODE_ENV === 'development' && <ReactQueryDevtools />}

            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </QueryClientProvider>
        </BreakpointProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
